<div class="container">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Hospitals</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field" (keyup)='applyFilter($event)'
          aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary" permission="Hospitals"
          [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" (click)="createHopital()">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
      <!--      <li>-->
      <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
      <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
      <!--        </div>-->
      <!--      </li>-->
    </ul>
  </div>



  <!--  <div class="container">-->
  <!--    <BR>-->
  <!--    <button *ngIf="hospital[0].all || hospital[0].add" color="accent" mat-raised-button id="create-center"  (click)="createHopital()"><mat-icon>add</mat-icon>&nbsp;Add Hospital</button>&nbsp;-->
  <!--  </div>-->
  <!--<BR>-->
  <!--  <br>-->
  <!--  <mat-form-field>-->
  <!--    <mat-label>Filter</mat-label>-->
  <!--    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>-->
  <!--  </mat-form-field>-->
  <div class="mat-elevation-z8">
    <table mat-table class="full-width-table" matSort [dataSource]="dataSource">
      <!-- Id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
        <td mat-cell *matCellDef="let row">{{row.id}}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="hospitalName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Hospital Name</th>
        <td mat-cell *matCellDef="let row">
          <span class="truncate-text" matTooltip="{{ row.hospitalName }}">
            {{ row.hospitalName }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Short Name</th>
        <td mat-cell *matCellDef="let row">{{row.shortName}}</td>
      </ng-container>
      <!-- City Column -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td mat-cell *matCellDef="let row">{{row.city}}</td>
      </ng-container>
      <!-- Doctor Name Column -->
      <ng-container matColumnDef="doctorsName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Doctor</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.drDetails?.length > 0; else noDoctor">
            <ng-container *ngFor="let doctor of row.drDetails; let i = index">
              {{ doctor.doctorsName}}{{ i < row.drDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noDoctor>
              {{ row.doctorsName || 'N/A' }}
            </ng-template>
        </td>
      </ng-container>

      <!-- Doctor Contact Column -->
      <ng-container matColumnDef="doctorContact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Doctor Contact</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.drDetails?.length > 0; else noDoctorContact">
            <ng-container *ngFor="let doctor of row.drDetails; let i = index">
              {{ doctor?.phoneNo || 'N/A' }}{{ i < row.drDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noDoctorContact>
              N/A
            </ng-template>
        </td>
      </ng-container>

      <!-- Social Worker Name Column -->
      <ng-container matColumnDef="socialWorker">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Social Worker</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.socialWorkerDetails?.length > 0; else noWorker">
            <ng-container *ngFor="let worker of row.socialWorkerDetails; let i = index">
              {{ worker.socialWorkerName}}{{ i < row.socialWorkerDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noWorker>
              {{ row.socialWorkerName || 'N/A' }}
            </ng-template>
        </td>
      </ng-container>

      <!-- Social Worker Contact Column -->
      <ng-container matColumnDef="socialWorkerContact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Social Worker Contact</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.socialWorkerDetails?.length > 0; else noWorkerContact">
            <ng-container *ngFor="let worker of row.socialWorkerDetails; let i = index">
              {{ worker?.phoneNo || 'N/A' }}{{ i < row.socialWorkerDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noWorkerContact>
              N/A
            </ng-template>
        </td>
      </ng-container>

      <!-- Administration Column -->
      <ng-container matColumnDef="administration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Administration</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.adminDetails?.length > 0; else noAdmin">
            <ng-container *ngFor="let admin of row.adminDetails; let i = index">
              {{ admin.name}}{{ i < row.adminDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noAdmin>
              N/A
            </ng-template>
        </td>
      </ng-container>

      <!-- Administration Contact Column -->
      <ng-container matColumnDef="administrationContact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Administration Contact</th>
        <td mat-cell *matCellDef="let row" class="truncate-cell">
          <ng-container *ngIf="row.adminDetails?.length > 0; else noAdminContact">
            <ng-container *ngFor="let admin of row.adminDetails; let i = index">
              {{ admin?.phoneNo || 'N/A' }}{{ i < row.adminDetails.length - 1 ? ', ' : '' }} </ng-container>
            </ng-container>
            <ng-template #noAdminContact>
              N/A
            </ng-template>
        </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="min-width: 200px;"> Action </th>
        <td mat-cell *matCellDef="let element" style="white-space: nowrap; min-width: 200px;">
          <!--        <button mat-icon-button>-->
          <!--          <mat-icon>archive</mat-icon>Archive-->
          <!--        </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
          <!--        <button  mat-icon-button >-->
          <!--          <mat-icon>edit</mat-icon>Edit-->
          <!--        </button>&nbsp;&nbsp;&nbsp;-->
          <button permission="Hospitals" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" mat-icon-button
            color="accent" (click)="viewDialog(element)" matTooltip="View">

            <mat-icon>remove_red_eye</mat-icon>
          </button>

          <button permission="Hospitals" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" mat-icon-button
            color="primary" (click)="viewHospital(element)">

            <mat-icon>edit</mat-icon>
          </button>

          <button permission="Hospitals" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" mat-icon-button
            color="primary" (click)="openQuestionnaire(element)" matTooltip="Assessment & Questionnaire">
            <mat-icon>quiz</mat-icon>
          </button>



          <button permission="Hospitals" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]"
            mat-icon-button color="warn" (click)="delete(element)"
            matTooltip="Delete"><mat-icon>delete</mat-icon></button>

        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[25, 50, 100,1000]" aria-label="Select page">
    </mat-paginator>
  </div>

</div>